export default __webpack_public_path__ + "d0c1d7abdc44eb39ae088798fb43158f.png";